import http from "../http-common";

class DefaultParamsService {
  getByPK(id) {
    return http.get(`/defaultparams/${id}`);
  }

  updateByPK(id, data) {
    return http.put(`/defaultparams/${id}`, data);
  }
}

export default new DefaultParamsService();